




























































































































































import { Component, Prop } from 'vue-property-decorator';
import WSwitch from '@/components/WSwitch.vue';
import Base from '@/views/Base';
import { CreateSurveyElement, SurveyChartType } from '@/models/Presentation';
import SurveyPreview from '@/views/presentation/components/SurveyPreview.vue';
import HtmlSelect from '@/components/HtmlSelect.vue';
import HtmlSelectOption from '@/components/HtmlSelectOption.vue';
import { ACCEPT_IMAGE } from '@/utils/files';

@Component({
  components: { HtmlSelectOption, HtmlSelect, SurveyPreview, WSwitch }
})
export default class AddSurveyModal extends Base {
  @Prop() survey!: CreateSurveyElement;
  @Prop() surveyBackground!: { file: File | null, url: string | null}
  @Prop() colorSchemeOptions!: { text: string, value: string[] }[];
  @Prop() validations!: any;

  ACCEPT_IMAGE = ACCEPT_IMAGE;

  chartOptions: { value: SurveyChartType, icon: string }[] = [
    { value: 'BAR_CHART_V', icon: 'columns' },
    { value: 'BAR_CHART_H', icon: 'bars' },
    { value: 'DOUGHNUT_CHART', icon: 'donut' },
    { value: 'PIE_CHART', icon: 'pie' },
  ];

  questionTypeOptions = [
    { value: 'SINGLE_CHOICE', text: this.$t('presentation.survey.singleChoice') },
    { value: 'MULTIPLE_CHOICE', text: this.$t('presentation.survey.multipleChoice') }
  ];

  addAnswer() {
    const idx = this.survey.answers.length;
    const color = this.survey.colorScheme[idx % this.survey.colorScheme.length];
    this.survey.answers.push({ idx, text: '', correct: false, color: color });
  }

  deleteAnswer(idx: number) {
    this.survey.answers.splice(idx, 1);
    this.colorSchemeUpdated();
  }

  selectColorScheme(colorScheme: string[]) {
    console.log('Color scheme selected:', colorScheme);
    this.survey.colorScheme = colorScheme;
    this.colorSchemeUpdated()
  }

  allCorrectChanged() {
    if(!this.survey.correctAnswers) {
      this.survey.answers.forEach((answer) => {
        answer.correct = false;
      });
    }
  }

  pictureUploaded(files: File[]){
    if(files.length == 0){
      return;
    }

    const file: Blob = files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (e) => {
      if (e.target) {
        this.surveyBackground.url = e.target.result as string;
        this.surveyBackground.file = files[0];
        this.survey.backgroundChanged = true;
        console.log('Logo uploaded');
      }
    };

  }

  colorSchemeUpdated(){
    this.survey.answers.forEach((answer, idx) => {
      answer.color = this.survey.colorScheme[idx % this.survey.colorScheme.length];
      answer.idx = idx;
    });
  }
  deleteBackground() {
    this.surveyBackground.file = null;
    this.surveyBackground.url = null;
    this.survey.backgroundChanged = true;
  }
}

